import styled from "styled-components";
import { Box } from "@mui/material";

export const ContactUsWrapper = styled(Box)`
	padding: 60px 40px;

	.title {
		font-family: var(--poppins), sans-serif;
		font-weight: bold;
		font-size: 34px;
		color: #373737;
	}
	.sub-title-wrapper {
		display: flex;
		justify-content: center;
		padding: 0 100px;
		text-align: center;
		margin-top: 60px;
		.sub-title {
			font-family: var(--poppins), sans-serif;
			font-size: 22px;
		}
	}

	.social_wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-decoration: none;
		color: ${({ theme }) => theme.palette.text.primary};

		.social {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 10px;
			background: ${({ theme }) => theme.custom_palette.color2};
			cursor: pointer;
			padding: 50px;
			border-radius: 5px;
			width: 200px;
			transition: all 0.4s;
			&:hover {
				transform: scale(1.05);
			}
			svg {
				width: 40px;
				height: 40px;
				fill: ${({ theme }) => theme.palette.secondary.dark};
			}
		}
	}

	.info_item {
		text-decoration: none;
		color: ${({ theme }) => theme.palette.text.primary};
		//background: #ffe3e4;
		//padding: 10px;
		//border-radius: 5px;
		.info_icon {
			fill: ${({ theme }) => theme.palette.secondary.dark};
			width: 22px;
			height: 22px;
		}

		.info_text {
			font-family: var(--openSans), sans-serif;
			font-size: 15px;
		}
	}

	${props => props.theme.breakpoints.down("sm")} {
		padding: 60px 0;
		.title {
			font-size: 28px;
		}
		.sub-title-wrapper {
			padding: 10px;
			margin-top: 30px;

			.sub-title {
				font-size: 18px;
			}
		}
		.social_wrapper {
			.social {
				padding: 30px;
			}
		}
	}
`;
